import { Box, Typography } from '@mui/material';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

import { tss } from 'tss-react/mui';

const LegalNotice = () => {
  const { classes } = useStyles();
  return (
    <Box className={classes.wrapper}>
      <Helmet>
        <title>Legal notice</title>
      </Helmet>
      <Typography variant="h1" sx={{ textAlign: 'center', my: 5 }}>
        Legal notice
      </Typography>
      <Typography variant="h2">
        Thank you for visiting this Givaudan web site.
      </Typography>
      <Typography variant="h3">Terms of Use</Typography>
      <Typography variant="body1">
        While Givaudan is making reasonable efforts to include accurate and
        up-to-date information in its web sites, Givaudan makes no
        representations or warranties, expressed or implied, as to the accuracy
        or completeness of such information. Givaudan may change its web sites
        at any time without notice but does not assume any responsibility to
        update them.
        <br />
        <br />
        Access and use of any Givaudan web site is at the sole risk of the user.
        Even though Givaudan takes reasonable measures to provide trouble-free
        use of its web sites, Givaudan does not warrant that its web sites,
        servers or e-mails are free of viruses or other harmful components.
        Givaudan will not be liable for any damages of any kind, including but
        not limited to, direct, incidental, consequential, indirect or punitive
        damages, arising from the access, use or inability to use Givaudan web
        sites, or for errors or omissions in their content.
        <br />
        <br />
        The information provided on Givaudan websites and specifically on
        Givaudan.com's investor pages does not constitute an offer of or
        solicitation for the purchase or disposal, trading or any transaction in
        any Givaudan securities. Investors must not rely on this information for
        investment decisions. Givaudan websites and specifically on
        Givaudan.com's investor pages may contain forward-looking information.
        Such information is subject to a variety of significant uncertainties,
        including scientific, business, economic and financial factors, and
        therefore actual results may differ significantly from those presented.
        <br />
        <br />
        Links to third-party web sites are provided for convenience only. Access
        and use of such web sites is at the sole risk of the user. Givaudan does
        not express any opinion on their content and will not be liable for any
        damages of any kind, including but not limited to direct, incidental,
        consequential, indirect or punitive damages, arising from the access,
        use or inability to use third-party web sites, or for errors or
        omissions in their content.
      </Typography>
      <Typography variant="h3">Copyright Notice</Typography>
      <Typography variant="body1">
        All information on Givaudan web sites, including trade marks or other
        intellectual property, is either the property of Givaudan SA or its
        affiliated companies, or is used with the authorisation of the owners,
        and subject to copyright.
        <br />
        <br />
        Any reproduction, retransmission or other use of such information is
        strictly prohibited without consent of Givaudan.
      </Typography>
      <Typography variant="h3">Privacy and cookies</Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: theme => theme.spacing(1)
        }}
      >
        <Typography
          component={Link}
          to="https://www.givaudan.com/legal/global-privacy-notice-condensed"
        >
          {'> Read more about our Global privacy notice'}
        </Typography>
        <Typography
          component={Link}
          to="https://www.givaudan.com/legal/cookies-policy"
        >
          {'> Read more about our Cookies policy'}
        </Typography>
        <Typography
          component={Link}
          to="https://www.givaudan.com/legal/global-candidate-privacy-notice"
        >
          {'> Read more about our Candidate privacy notice'}
        </Typography>
      </Box>
    </Box>
  );
};

export default LegalNotice;
const useStyles = tss.create(({ theme }) => ({
  wrapper: {
    h3: {
      marginTop: theme.spacing(1.5),
      marginBottom: theme.spacing(1.5)
    },
    a: {
      color: theme.palette.primary.main,
      ':hover': {
        color: theme.palette.secondary.main
      }
    }
  }
}));
